import axios from 'axios'

export default {
    getPeople(){
        return axios.get('/people/')
            .then(response => {
                return response.data
            })
    },
    getPeopleDatasource(params){
        return axios.get('/people/datasource', {params})
            .then(response => {
                return response.data
            })
    },
    getPeopleDatasourceUser(params){
        return axios.get('/people/datasource_user', {params})
            .then(response => {
                return response.data
            })
    },
    getPeoplebyID(id){
        return axios.get('/people/' + id + '/details')
            .then(response => {
                return response.data
            })
    },  
    updatePeople(id,formdata){
        return axios.put('/people/' + id + '/update', formdata  )
            .then(response => {
                return response.data
            })
    },
    convertToMember(id){
        return axios.get('/people/' + id + '/converttomember')
            .then(response => {
                return response.data
            })
    },
    convertToVisitor(id){
        return axios.get('/people/' + id + '/converttovisitor')
            .then(response => {
                return response.data
            })
    },
    setPortalAccess(id){
        return axios.get('/people/' + id + '/setportalaccess')
            .then(response => {
                return response.data
            })
    },
    resetPasswordPeople(id){
        return axios.get('/people/' + id + '/resetpassword')
            .then(response => {
                return response.data
            })
    },
    deactivatePeople(id){
        return axios.put('/people/' + id + '/deactivate')
            .then(response => {
                return response.data
            })
    },
    reactivatePeople(id){
        return axios.put('/people/' + id + '/reactivate')
            .then(response => {
                return response.data
            })
    },
    assign_relation(id,formdata){
        return axios.post('/people/' + id + '/setrelation', formdata)
            .then(response => {
                return response.data
            })
    }, 
    remove_relation(id,formdata){
        return axios.post('/people/' + id + '/removerelation', formdata)
            .then(response => {
                return response.data
            })
    },
    get_relation_list(){
        return axios.get('/people/getrelationlist')
        .then(response => {
            return response.data
        })
    },
    get_address(id){
        return axios.get('/people/' + id + '/get_address')
            .then(response => {
                return response.data
            })
    }, 
    add_address(id,formdata){
        return axios.post('/people/' + id + '/add_address', formdata)
            .then(response => {
                return response.data
            })
    }, 
    update_address(id,formdata){
        return axios.post('/people/' + id + '/update_address', formdata)
            .then(response => {
                return response.data
            })
    }, 
    delete_address(id){
        return axios.delete('/people/' + id + '/delete_address')
            .then(response => {
                return response.data
            })
    }, 
}